import React, { Fragment, useCallback, useMemo } from 'react';
import { renderToString } from 'react-dom/server';
import T from 'prop-types';
import { times } from 'lodash-es';

import EmptyBox from './EmptyBox';
import Skeleton from '../../../Skeleton';
import MapChart from '../../../Chart/MapChart';
import RatingCountries from '../../../RatingCountries';

import { getMetricName, valueFormatter } from '../../configs/pub-quickview';

const emptyArray = [];
const colorList = ['#EDF5FD', '#D6E8F9', '#AED1F4', '#85BAEE', '#5DA3E9', '#348BE3'];

const PubMapChart = ({
  settings,
  metric,
  dataMap,
}) => {
  const dataRating = dataMap[metric] || emptyArray;
  const showData = !settings.pending && !settings.error;
  const dataPresent = dataRating.some(item => item.value);

  const metricName = getMetricName(metric);

  const series = useMemo(() => dataRating.reduce((acc, value) => {
    if (value.country_iso === 'other') return acc;
    return { ...acc, [value.country_iso]: value.value };
  }, {}), [dataRating]);

  const tooltipFormatter = useCallback(point => renderToString((
    <Fragment>
      <tr>
        <td className="text-left p-a-0">
          Country:
          <span className="text-left p-l-xxs">{point.key}</span>
        </td>
      </tr>
      <tr>
        <td className="text-left p-a-0">
          {metricName}:
          <span className="text-left p-l-xxs">
            {valueFormatter(point.point.value, metric)}
          </span>
        </td>
      </tr>
    </Fragment>
  )), [metricName, metric]);

  return (
    <div className="prospects-sidebar__map prospects-sidebar__box">
      <h2 className="country-title text-black h4">Top Countries by {metricName}</h2>
      {settings.pending && times(5).map(n => <Skeleton key={n} height={n === 0 ? 245 : 24} />)}
      {showData && (
        dataPresent ? (
          <Fragment>
            <MapChart
              chartId="world-map-chart"
              series={series}
              colorList={colorList}
              count={6}
              height={300}
              tooltipPadding={16}
              legendEnabled={false}
              legendTitle=""
              tooltipFormatter={tooltipFormatter}
            />
            <RatingCountries
              countries={dataRating}
            />
          </Fragment>
        ) : <EmptyBox text="No country data detected" />
      )}
    </div>
  );
};

PubMapChart.propTypes = {
  settings: T.object.isRequired,
  metric: T.string.isRequired,
  dataMap: T.object,
};

export default PubMapChart;
